import React, { useState } from 'react';

import Link from 'next/link';

import { SliceZone } from '@prismicio/react';
import { IconButton } from '@repo/ui/components/Buttons';
import FacebookCircleIcon from '@repo/ui/components/Icon/FacebookCircleIcon';
import InstagramCircleIcon from '@repo/ui/components/Icon/InstagramCircleIcon';
import PinterestIcon from '@repo/ui/components/Icon/PinterestIcon';
import TwitterCircleIcon from '@repo/ui/components/Icon/TwitterCircleIcon';
import YoutubeCircleIcon from '@repo/ui/components/Icon/YoutubeCircleIcon';
import { P2 } from '@repo/ui/components/Typography';

import Logo from 'components/Logo/Logo';
import { components } from 'slices/index';
import { FlexRow } from 'styles/layouts';

import { document } from './data';
import {
  Wrapper,
  Container,
  LeftColumn,
  RightColumn,
  CopyrightText,
} from './styles';
import { iconButtonTheme } from './theme';

const socialLinks = [
  {
    href: 'https://www.facebook.com/kittldesign',
    icon: FacebookCircleIcon,
    label: 'Facebook',
  },
  {
    href: 'https://www.youtube.com/Kittldesign',
    icon: YoutubeCircleIcon,
    label: 'YouTube',
  },
  {
    href: 'https://www.instagram.com/kittldesign/',
    icon: InstagramCircleIcon,
    label: 'Instagram',
  },
  {
    href: 'https://twitter.com/kittldesign',
    icon: TwitterCircleIcon,
    label: 'Twitter',
  },
  {
    href: 'https://www.pinterest.com/kittldesign',
    icon: PinterestIcon,
    label: 'Pinterest',
  },
];

const NonFeedFooter = ({ newBackground }) => {
  const [footerLinks] = useState(document.data.slices);
  const currentYear = new Date().getFullYear();

  return (
    <Wrapper newBackground={newBackground}>
      <Container>
        <LeftColumn>
          <Logo dataTestId="footer--kittl-logo" height="30px" width="70px" />
          <P2>
            Easily create beautiful designs with Kittl using templates of
            world-class designers.
          </P2>
          <FlexRow gap="16px">
            {socialLinks.map(({ href, icon, label }) => (
              <Link key={icon} legacyBehavior passHref href={href}>
                <IconButton
                  ariaLabel={label}
                  as="a"
                  height="22px"
                  icon={icon}
                  rel="noreferrer"
                  target="_blank"
                  theme={iconButtonTheme}
                />
              </Link>
            ))}
          </FlexRow>
          <CopyrightText>© Kittl {currentYear}</CopyrightText>
        </LeftColumn>
        <RightColumn>
          <SliceZone components={components} slices={footerLinks} />
        </RightColumn>
      </Container>
    </Wrapper>
  );
};

export default NonFeedFooter;
